
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import { smsPurchase, getSmsComboes } from "@/api/api-basic-sms";
import i18n from "@/config/i18n";
import { getAllOperList } from "@/api/api-basic";
@Component({
  components: {}
})
export default class PiMessagerechargeBox extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("messageManage.msgRechange");
  private FormData: objAny = {};
  private operList: object[] = [];
  private purchasedCountList: object[] = [];

  private itemData: objAny = {};
  private ruleInline: objAny = {
    comboPkId: [
      {
        required: true,
        message: i18n.t("messageManage.comboPkIdPl"),
        trigger: "change"
      }
    ]
    // paymentAmount: [
    //   {
    //     required: true,
    //     message: "请选择短信条数",
    //     trigger: "change"
    //   }
    // ]
  };
  private formItem: objAny = {
    agent: 1,
    oprPkId: "",
    comboPkId: "",
    paymentAmount: "",
    purchasedCount: "",
    purchasedWay: "2",
    remark: ""
  };

  public open(item: objAny) {
    this.itemData = item;
    this.formItem.oprPkId = item.oprPkId;
    this.formItem.comboPkId = "";
    this.formItem.paymentAmount = "";
    this.formItem.purchasedCount = "";
    this.formItem.remark = "";
    this.modalShow = true;
    this.getSmsComboes();
  }
  async getStation(): Promise<void> {
    const ret = await getAllOperList({});
    if (ret.status === this.$config.apiStatus) {
      this.operList = ret.data;
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formItem;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await smsPurchase(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }

  async getSmsComboes(): Promise<void> {
    const ret = await getSmsComboes({});
    if (ret.status === this.$config.apiStatus) {
      this.purchasedCountList = ret.data;
    }
  }
  public purchasedCountChange() {
    this.purchasedCountList.map((item: objAny) => {
      if (item.comboPkId == this.formItem.comboPkId) {
        this.formItem.purchasedCount = item.number;
        this.formItem.paymentAmount = item.price;
      }
    });
  }
  mounted() {
    // this.getOptionList();
    this.getStation();
  }
}
